
import Vue from 'vue'
import store from './store/index'
import VueCookie from 'vue-cookie'
import VueLocalStorage from 'vue-localstorage'
import VueMaterial from 'vue-material'
import VueFormWizard from 'vue-form-wizard'
// import SideBar from "./components/SidebarPlugin";
import 'vue-material/dist/vue-material.min.css'
import Chartist from "chartist";
import { SET_USER_FROM_COOKIE, SET_AUTHENTICATED_USER, LOGOUT_USER } from './store/action-types'
import App from './main.vue'
import router from './router/index.js'
import VueGoodTablePlugin from 'vue-good-table';
import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import 'vue-good-table/dist/vue-good-table.css'
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueClip from 'vue-clip'
import IdleVue from "idle-vue";
const eventsHub = new Vue();

import 'vue-multiselect/dist/vue-multiselect.min.css';

Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 900000, // 15 minutes
    startAtIdle: false
});

require('sweetalert2/dist/sweetalert2.min.css')
require('babel-polyfill/dist/polyfill.min')
require('./assets/scss/material-dashboard.scss')
require('vue-form-wizard/dist/vue-form-wizard.min.css')

Vue.use(VueClip)
Vue.use(DateRangePicker)
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
Vue.use(VueFormWizard)
Vue.use(VueLocalStorage)
Vue.use(VueCookie)
Vue.use(VueMaterial)
Vue.use(Chartist)
Vue.config.productionTip = false
Vue.use(VueGoodTablePlugin);
Vue.use(VueSidebarMenu)

const { state } = store

// Load User From Cookie if existed
let token = VueCookie.get('token')
let refreshToken = VueCookie.get('remember_token')
let authUser = Vue.localStorage.get('authUser')


if (authUser !== null) {
    store.commit(SET_AUTHENTICATED_USER, JSON.parse(authUser))
}

if (token !== null) {
    store.commit(SET_USER_FROM_COOKIE, { token, refreshToken })
    store.dispatch('refreshAuthUser', {
        store: store,
        localStorage: Vue.localStorage
    })
}

// Router Interceptor
router.beforeEach(function (to, from, next) {
    // Checking API Availability
    store.dispatch('checkApiAvailability').finally(() => {
        if (!state.appStore.api.isOnline && to.path !== '/error') {
            next({ path: '/error' })
        }
    })

    // Authorization and Rerouting
    var guest = state.userStore.token === null || state.userStore.authUser === null,
        requiresAuth = to.matched.some(record => record.meta.requiresAuth),
        requiresGuest = to.matched.some(record => record.meta.requiresGuest)

    if (guest) {
        store.commit(LOGOUT_USER)
        Vue.cookie.delete('token')
        Vue.cookie.delete('refresh_token')
        Vue.localStorage.remove('authUser')
    }

    if (requiresAuth && guest) {
        store.commit('setRedirectRoute', to.fullPath);
        next({ path: '/login' })
    } else if (requiresGuest && !guest) {
        next({ path: '/administrator' })
    } else {
        next()
    }
})

const app = new Vue({
    store,
    router,
    template: '<App/>',
    components: {
        App
    }
}).$mount('#app')

export default app


// WEBPACK FOOTER //
// ./resources/js/main.js